import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const dismissKey = (userId) => `ga_password_banner_dismissed_${userId}`;

export default function SetCredentialsBanner() {
  const navigate = useNavigate();
  const { user, isSuperAdmin } = useAuth();
  const [dismissed, setDismissed] = useState(() =>
    user?.id ? localStorage.getItem(dismissKey(user.id)) === '1' : false
  );

  // `has_password` is undefined until the session is refreshed against the
  // post-migration backend. Treat unknown as "don't show" so existing
  // logged-in users with a password never see a false-positive banner.
  if (!user || isSuperAdmin || user.has_password !== false || dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(dismissKey(user.id), '1');
    setDismissed(true);
  };

  return (
    <div className="flex items-start justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 dark:border-amber-700 dark:bg-amber-900/20">
      <div className="flex items-start gap-3 min-w-0">
        <ShieldAlert className="h-5 w-5 shrink-0 text-amber-600 dark:text-amber-400 mt-0.5" aria-hidden="true" />
        <div>
          <p className="text-sm font-medium text-amber-900 dark:text-amber-100">
            Secure your account
          </p>
          <p className="mt-0.5 text-xs text-amber-800 dark:text-amber-200">
            You signed in with OTP but haven&apos;t set a password yet. Set one so you can also sign in with your phone number and password.
          </p>
          <button
            type="button"
            onClick={() => navigate('/dashboard/profile')}
            className="mt-2 rounded-lg bg-amber-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-amber-700"
          >
            Set password
          </button>
        </div>
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        className="rounded-full p-1 text-amber-700 hover:bg-amber-100 dark:text-amber-300 shrink-0"
        onClick={handleDismiss}
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
